// extracted by mini-css-extract-plugin
export var box = "_4q-1";
export var checkboxRow = "_4q-8";
export var checked = "_4q-2";
export var descriptionSpacer = "_4q-a";
export var disabled = "_4q-3";
export var icon = "_4q-6";
export var input = "_4q-0";
export var labelSpacer = "_4q-9";
export var medium = "_4q-5";
export var small = "_4q-4";
export var text = "_4q-7";